export enum DateType {
  Departure,
  Arrival,
}

export enum TimeTitleKey {
  PlannedDepartureTime = 'plannedDepartureTime',
  PlannedArrivalTime = 'plannedArrivalTime',
  EstimatedDepartureTime = 'estimatedDepartureTime',
  EstimatedArrivalTime = 'estimatedArrivalTime',
  ActualDepartureTime = 'actualDepartureTime',
  ActualArrivalTime = 'actualArrivalTime',
}
